// @core/api/endpoints/team/get_team.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  TeamResponse,
} from '../../../types/team';

const BASE_PATH = '/team';

/**
 * Get team by ID
 * Retrieves basic information about a team including its name, description, and settings.
 */
export async function GetTeam(
  team_id: string,
  options?: RequestOptions
): Promise<TeamResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:team_id`;
  requestPath = requestPath.replace(':team_id', encodeURIComponent(team_id));
  const requestOptions = options;
  return client.get<TeamResponse>(requestPath, { ...requestOptions });
}
